import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import { CatalogData, CatalogDetail, CatalogResponse } from "./CatalogType";
import { fetchCatalogThunk } from "./catalog.actions";

export const fetchCatalog = createAsyncThunk(
  "catalog/fetchCatalog",
  fetchCatalogThunk
);

const initialState: CatalogData = {
  catalog: null,
  is_fetch: false,
};

const CatalogSlice = createSlice({
  name: "catalog",
  initialState,
  reducers: {
    clearValues: (state) => {
      state = initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCatalog.fulfilled, (state, { payload }) => {
        return {
          ...state,
          catalog: payload,
          is_fetch: true,
        };
      })
      .addCase(fetchCatalog.pending, (state) => {
        return {
          ...state,
          catalog: null,
          is_fetch: false,
        };
      })
      .addCase(fetchCatalog.rejected, (state) => {
        return {
          ...state,
          catalog: null,
          is_fetch: false,
        };
      });
  },
});

export const { clearValues } = CatalogSlice.actions;
export default CatalogSlice.reducer;
